import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Coordinates } from '../classes/geo-location-object';
import { COORDINATES_PATTERN } from '../common/constants';
import { GeoLocationService } from './geo-location.service';
import { IosService } from './ios.service';
import { LoggerService } from './logger.service';

export interface IOSInfo {
  isIOSWebView: boolean;
  coordinateSource: string;
}


@Injectable({
  providedIn: 'root'
})
export class CoordinatesService implements OnDestroy {

  coordinates$: BehaviorSubject<Coordinates> = new BehaviorSubject(null)
  unsubscribe$: Subject<boolean> = new Subject();
  coordinatesSource$: BehaviorSubject<string> = new BehaviorSubject(null)
  iOSInfo$: BehaviorSubject<IOSInfo> = new BehaviorSubject(null)

  constructor(
    private jsCoordinatesService: GeoLocationService,
    private iOSCoordinatesService: IosService,
    private logger: LoggerService
    ) {
      combineLatest([
        this.jsCoordinatesService.location$,
        this.iOSCoordinatesService.location$])
        .pipe(
          takeUntil(this.unsubscribe$))
          .subscribe(([
            jsCoordinates,
            iOSCoordinates]) => {

              if(iOSCoordinates){ // if iOS then prefer iOS coords. if no ios coords then fall back to JS coords
               // console.log(`iOSCoordinates Latest: ${iOSCoordinates?.lat}, ${iOSCoordinates?.long}`);
                const coords: Coordinates = {
                  latitude: iOSCoordinates?.lat,
                  longitude: iOSCoordinates?.long
                }
                this.updateCoordinatesData(coords); // if(this.isIOSWebView() && this.validCoordinates(_iOSCoordinates)){
                this.updateCoordinatesSource('iOS');
              }else{
                if(jsCoordinates){
                //  console.log(`jsCoordinates Latest: ${jsCoordinates?.latitude}, ${jsCoordinates?.longitude}`);
                  const coords: Coordinates = {
                    latitude: jsCoordinates?.latitude,
                    longitude: jsCoordinates?.longitude
                  }
                  this.updateCoordinatesData(coords);
                  this.updateCoordinatesSource('JS');
                }
              }

            },
            err => console.error(err)
      );
  }

  init(){
    this.logger.info("Coordinates Service Initilized!");
  }


  updateCoordinatesData(data: any): void {
    this.coordinates$.next(data);
  }

  getCoordinatesData(): Observable<any> {
    return this.coordinates$.asObservable();
  }

  updateCoordinatesSource(data: string): void {
    this.coordinatesSource$.next(data);
  }

  getCoordinatesSource(): Observable<string> {
    return this.coordinatesSource$.asObservable();
  }

  updateIOSInfo(data: IOSInfo): void {
    this.iOSInfo$.next(data);
  }

  getIOSInfo(): Observable<IOSInfo> {
    return this.iOSInfo$.asObservable();
  }

  validCoordinates(coordinates: Coordinates): boolean{
    // console.log(`Coordinates are valid: ${COORDINATES_PATTERN.test(coordinates.latitude) && COORDINATES_PATTERN.test(coordinates.longitude)}`);
    return COORDINATES_PATTERN.test(coordinates.latitude) && COORDINATES_PATTERN.test(coordinates.longitude);
  }

  isIOSWebView(): boolean{
    var userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test( userAgent ),
    ios = /iphone|ipod|ipad/.test( userAgent );
    if( ios ) {
        if ( safari ) { //browser
            return false
        } else if ( !safari ) { //webview
            return true
        };
    } else { //not iOS
        return false
    };
    return false;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }


}
